import React from 'react';

const VideoGridOverlay = (props) => {
    return (
        <div className='relative' style={{ height: 'auto'}}>
            <img
                className="object-fit w-full video-grid"
                src={props.url}
                alt=""
            />
            <div className='absolute top-0 backdrop-blur-sm backdrop-brightness-50 h-full w-full'>
                <div className='flex flex-col items-center h-full relative justify-center'>
                {props.children}
                </div>
            </div>
        </div>
    );
};

export default VideoGridOverlay;